<template>
  <div class="video-library-wrapper video-iframe-edit">
    <div class="cursor-pointer" @click="openModal">
      <edit-icon class="edit-icon" />
    </div>
    <gd-modal
      @opened="videoLibraryOpened"
      @closed="videoLibraryClosed"
      ref="video-picker-modal"
      name="video-picker-modal"
      :title="$t('frontend_sites_video_picker_title')"
      hideClose
      width="80%"
      height="100%"
    >
      <template v-slot:actions>
        <div class="flex">
          <gd-button
            v-if="currentTab === 'Video Library'"
            variant="primary"
            size="auto"
            class="mr-4 p-4 mt-2"
            @click="emitSelection()"
          >
            Select
          </gd-button>

          <gd-button
            size="auto"
            class="mr-4 p-4 mt-2"
            @click="() => $refs['video-picker-modal'].close()"
          >
            Exit
          </gd-button>
        </div>
      </template>
      <div class="w-full bg-white">
        <div class="pt-3">
          <gd-tabs
            ref="tabs"
            :tabs="tabs"
            :activeByDefault="tabs[0]"
            :tabsWithErrors="tabsWithErrors"
            @tab-change="handleTabChange"
            @onClick="onTabClick"
          >
          </gd-tabs>
        </div>
        <div class="steps-wrapper custom-scrollbars overflow-y-auto">
          <div>
            <div class="steps-inner p-5">
              <div v-if="currentTab === 'Video Library'">
                <my-videos
                  ref="myVideos"
                  :value="value"
                  :srcType="srcType"
                  @selected="selectVideo($event, null)"
                ></my-videos>
              </div>
              <div v-if="currentTab === 'Upload Video'">
                <gd-video-uploader
                  @sendBackToLibrary="$refs.tabs.openTab('Video Library')"
                ></gd-video-uploader>
              </div>
              <div v-if="currentTab === 'Youtube Video'">
                <youtube-videos
                  @sendBackToLibrary="$refs.tabs.openTab('Video Library')"
                ></youtube-videos>
              </div>
              <div v-if="currentTab === 'Vimeo Video'">
                <vimeo-videos
                  @selected="selectVideo($event, emitSelection)"
                ></vimeo-videos>
              </div>
              <div v-if="currentTab === 'Wistia Video'">
                <wistia-videos
                  @selected="selectVideo($event, emitSelection)"
                ></wistia-videos>
              </div>
              <div v-if="currentTab === 'Embed Code'">
                <embed-code
                  @selected="selectVideo($event, emitSelection)"
                ></embed-code>
              </div>
              <div v-if="currentTab === 'External URL'">
                <external-url
                  @sendBackToLibrary="$refs.tabs.openTab('Video Library')"
                ></external-url>
              </div>
            </div>
          </div>
        </div>
      </div>
    </gd-modal>
  </div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import EditIcon from '../../assets/round-edit.svg';
import mixins from '../../mixins';
import GdModal from '../Modal';
import GdTabs from '../Tabs';
import EmbedCode from './EmbedCode';
import ExternalUrl from './ExternalVideos';
import MyVideos from './MyVideos';
import GdVideoUploader from './VideoUploader';
import VimeoVideos from './VimeoVideos';
import WistiaVideos from './WistiaVideos';
import YoutubeVideos from './YoutubeVideos';

export default {
  name: 'VideoLibrary',
  mixins: [mixins],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          videoEmbed: '',
          videoSrc: '',
        };
      },
    },
    dark: {},
    primary: { default: true },
    srcType: {},
    tabs: {
      type: Array,
      default: () => {
        return [
          'Video Library',
          // 'External URL',
          'Youtube Video',
          'Vimeo Video',
          'Wistia Video',
          'Embed Code',
        ];
      },
    },
  },
  data() {
    return {
      selectedVideo: null,
      currentTab: 'Video Library',
      tabsWithErrors: [],
      inactiveTabs: ['Upload Video', 'External URL'],
    };
  },
  components: {
    GdTabs,
    GdModal,
    GdVideoUploader,
    MyVideos,
    ExternalUrl,
    YoutubeVideos,
    VimeoVideos,
    WistiaVideos,
    VuePerfectScrollbar,
    EditIcon,
    EmbedCode,
  },
  methods: {
    handleTabChange(param) {
      this.currentTab = param;
    },
    onTabClick(param) {
      console.log('onTabClick', param);
    },
    selectVideo(video, next = null) {
      this.selectedVideo = video;

      if (next) {
        next();
      }
    },
    emitSelection() {
      this.$emit('selected', this.selectedVideo);
      this.$refs['video-picker-modal'].close();
    },
    openModal() {
      this.$refs['video-picker-modal'].open();
    },
    videoLibraryOpened(event) {
      const libraryContainer = document.getElementById('video-library-height');

      if (libraryContainer) {
        libraryContainer.classList.add('removeheight');
      }
    },
    videoLibraryClosed() {
      const libraryContainer = document.getElementById('video-library-height');

      if (libraryContainer) {
        libraryContainer.classList.remove('removeheight');
      }
    },
  },
};
</script>
<style scoped>
.steps-inner {
  height: calc(100vh - 145px);
}
</style>